
const noop = (value?:any) => { };

export const wsConnect = (link, { retry = Infinity, onMessage, onOpen = noop, onClose = noop, onReconnect = noop, ping }:any) => {
    const ws:any = new WebSocket(link);
    let pingInterval;
    ws.onopen = () => {
      onOpen(ws);
      if (ping) {
        pingInterval = ping(ws);
      }
    };
  
    ws.onmessage = onMessage;
  
    ws.onclose = (e) => {
      if (pingInterval) {
        clearInterval(pingInterval);
      }
      if (retry === 0) {
        return onClose(e);
      }
  
      setTimeout(() => {
        onReconnect();
        console.log("onReconnect",e)
        wsConnect(link, { retry: retry - 1, onMessage, onOpen, onClose, onReconnect, ping });
      }, 1000);
    };
  
    ws.onerror = (e) => {
      console.error(`ws-connect error`, e);
      ws.close();
    };
  };
  